export const shopDomain = 'https://shop.yartf.ru';

// const host = 'http://localhost:8080/api';
const host = 'https://yartf.ru/api';

export default {
  FILTERS_API: `${host}/filters`,
  PRODUCTS_API: `${host}/products`,
  ORDERS_API: `${host}/orders`,
  PRODUCT_API: `${host}/products/:productId`,
};



// WEBPACK FOOTER //
// ./src/api/endpoints.js